import React, { useState, Fragment } from "react"

import ToolTip from "@/components/core/ToolTip/ToolTip"
import toolTipIcon from "@/public/icons/tooltip-bundles.svg"

import { accordionUniqueId } from "@/utils/index"

import accordionStyles from "@/components/core/Accordion/Accordion.module.scss"
import Style from "@/components/MultiFinshProductBundle/styles/BundleDetailsAccordianUI.module.scss"

import Collapsible from "react-collapsible"
import CollapsibleHeader from "@/components/Bundles/StaticBundle/BundlesAccordian/CollapsibleHeader"

import {
  accordianClickBundleFeature,
  dimensionsTooltipAnalyticsData,
} from "@/components/MultiFinshProductBundle/analytics"

const BundleDimensionsUI = props => {
  const {
    data = [],
    label = "",
    config = {},
    productInfoBundle = {},
  } = props || {}

  const [activeTooltipIdx, setActiveTooltipIdx] = useState(-1)

  const { regexPattern: { map: { productDimensionsRegex = "" } = {} } = {} } =
    config

  const removeSpecialChars = str => {
    const strValue = String(str || "")
    const regex = new RegExp(productDimensionsRegex)
    return strValue.replace(regex, "")
  }

  const tooltipHover = (index, message) => {
    setActiveTooltipIdx(index)
    dimensionsTooltipAnalyticsData(label, message, productInfoBundle)
  }

  const handleOpenAccordian = (title = "") => {
    accordianClickBundleFeature(
      title.toLowerCase(),
      "expand",
      productInfoBundle
    )
  }
  const handleCloseAccordian = (title = "") => {
    accordianClickBundleFeature(
      title.toLowerCase(),
      "collapse",
      productInfoBundle
    )
  }

  return (
    <div
      className={`${accordionStyles.accordionWrapper} ${Style.BundlesDetailsAccordianUI} container-fluid`}
    >
      <div
        className={`collapsible-accordion bundle-accordian-section ${label.toLowerCase()}`}
        data-testid={`bundle-product-accordion-${label}`}
      >
        <Collapsible
          trigger={<CollapsibleHeader title={label} />}
          onTriggerOpening={() => handleOpenAccordian(label)}
          onTriggerClosing={() => handleCloseAccordian(label)}
          triggerOpenedClassName="collapsible__trigger--open"
          open={false}
          openedClassName="collapsible--open"
          transitionTime={400}
          tabIndex="0"
          easing="ease-in-out"
          triggerElementProps={{
            id: accordionUniqueId("collapsible-trigger", 9999, 1000),
          }}
          contentElementId={accordionUniqueId(
            "collapsible-content",
            9999,
            1000
          )}
        >
          {data.map(item => {
            const { dimensionData = [] } = item || {}
            return (
              <div
                key={item.sku}
                className={`col-12 ${Style.accordianContainer}`}
              >
                <p className="sku-title">{item.customerFacingSku}</p>
                <p className="title">{item.name}</p>
                <div className="bundle-dimensions">
                  <div className="container">
                    {dimensionData.map((d, index) => {
                      return d.value ? (
                        <Fragment key={`${d.key}-${item.sku}`}>
                          <div
                            className={`label ${
                              index % 2 === 0 ? "highlighted" : ""
                            }`}
                          >
                            <span>{d.label}</span>
                            {d.tooltip ? (
                              <>
                                <img
                                  className="tooltipIcon"
                                  src={toolTipIcon?.src}
                                  alt={"Tooltip"}
                                  onMouseLeave={() => {
                                    setActiveTooltipIdx(-1)
                                  }}
                                  onMouseOver={() => {
                                    tooltipHover(
                                      String(`${d.key}-${item.sku}`),
                                      d.tooltip
                                    )
                                  }}
                                  onFocus={() => {
                                    tooltipHover(
                                      `${d.key}-${item.sku}`,
                                      d.tooltip
                                    )
                                  }}
                                  onBlur={() => {
                                    setActiveTooltipIdx(-1)
                                  }}
                                />
                                {String(activeTooltipIdx) ===
                                `${d.key}-${item.sku}` ? (
                                  <ToolTip message={d.tooltip} />
                                ) : null}
                              </>
                            ) : null}
                          </div>
                          <span
                            className={`value ${
                              index % 2 === 0 ? "highlighted" : ""
                            }`}
                          >
                            {`${removeSpecialChars(d.value)} ${d?.unit ?? ""}`}
                          </span>
                        </Fragment>
                      ) : null
                    })}
                  </div>
                </div>
              </div>
            )
          })}
        </Collapsible>
      </div>
    </div>
  )
}
export default BundleDimensionsUI
